import styled from 'react-emotion';
import { css } from 'emotion';

export const MarkListWrap = styled('div')`
      overflow: auto;
      height: 100%;
`;

export const draggable = css`
  border: 1px solid #e8e8e8;
  padding-left: 16px;
    padding-right: 16px;
`;



// WEBPACK FOOTER //
// ./src/containers/DraggableListPlacemark/styled.js